import { QuestionRequest } from 'model/request';
import axiosInstance from '../axios/axiosInstance';
import { Page, QuestionWithChildren } from '../model/response';

export const pageQuestions = async (params: any) => {
  const { data } = await axiosInstance.get<Page<QuestionWithChildren>>('questions/page', { params });
  return data;
};

export const findQuestionImportRequest = async (id: string) => {
  const { data } = await axiosInstance.get<QuestionRequest>(`questions/${id}/question-request`);
  return data;
};

export const updateQuestion = async (question: QuestionRequest) => {
  const { data } = await axiosInstance.put(`questions`, question);
  return data;
};

export const checkDuplicateCode = async (id: string, code: string) => {
  const { data } = await axiosInstance.get(`questions/${id}/code/${code}`);
  return data;
};

export const toggleQuestionWebviewActive = async (id: string) => {
  await axiosInstance.patch(`questions/${id}/toggle-web-view-active`);
};

export const softDeleteQuestion = async (id: string) => {
  await axiosInstance.delete(`questions/${id}`);
};
